import React, { useEffect, useRef, useState } from "react";
import { JimiEmpty } from "../../components/Jimi";
import { X, ChevronRight } from "lucide-react";
export function Panel({ title, children, action }) {
  return (
    <section className="panel">
      {(title || action) && <div className="cardHeading">
        {title && <h2>{title}</h2>}
        {action}
      </div>}
      {children}
    </section>
  );
}
export function Field({ label, ...props }) {
  return (
    <label className="field">
      {label}
      {props.required ? " *" : ""}
      <input {...props} />
    </label>
  );
}
export function Select({ label, children, ...props }) {
  return (
    <label className="field">
      {label}
      {props.required ? " *" : ""}
      <select aria-label={label} {...props}>
        {children}
      </select>
    </label>
  );
}
export function TextArea({ label, ...props }) {
  return (
    <label className="field">
      {label}
      <textarea {...props} />
    </label>
  );
}
export function Form({ onSubmit, children }) {
  const [error, setError] = useState("");
  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        setError("");
        try {
          await onSubmit(new FormData(e.currentTarget));
        } catch (err) {
          setError(err.message || "Impossible d’enregistrer.");
        }
      }}
    >
      {children}
      {error && (
        <p className="error" role="alert">
          {error}
        </p>
      )}
    </form>
  );
}
export function Modal({ title, children, onClose }) {
  const ref = useRef(null),
    close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const previous = document.activeElement;
    ref.current?.querySelector("input,select,textarea,button")?.focus();
    const handler = (e) => {
      if (e.key === "Escape") close.current();
      if (e.key !== "Tab") return;
      const controls = [
        ...ref.current.querySelectorAll(
          "button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),a[href]",
        ),
      ];
      const first = controls[0],
        last = controls.at(-1);
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last?.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first?.focus();
      }
    };
    document.addEventListener("keydown", handler);
    const before = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.style.overflow = before;
      previous?.focus();
    };
  }, []);
  return (
    <div className="overlay">
      <div
        ref={ref}
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <button
          className="close"
          aria-label="Fermer la fenêtre"
          onClick={onClose}
        >
          <X />
        </button>
        <h2 id="modal-title">{title}</h2>
        {children}
      </div>
    </div>
  );
}
export function Action({ tag, title, sub, onClick }) {
  return (
    <button className="action" onClick={onClick}>
      <span className="tag">{tag}</span>
      <div>
        <b>{title}</b>
        {sub && <small>{sub}</small>}
      </div>
      <ChevronRight />
    </button>
  );
}
export function Empty({ children = "Aucune donnée pour ce filtre." }) {
  return <JimiEmpty>{children}</JimiEmpty>;
}
export function K({ n, l }) {
  return (
    <div className="kpi">
      <div>
        <strong>{n}</strong>
        <span>{l}</span>
      </div>
    </div>
  );
}
